import type React from "react";
import { Button } from "~/components/form/Button";

interface CombinedTextFieldAndButtonProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	name: string;
	label?: string;
	value?: string;
	display?: "stacked" | "inline";
	required?: boolean;
	invalid?: boolean;
	valid?: boolean;
	disabled?: boolean;
	theme?: Theme;

	buttonName: string;
	buttonLabel: string;
	buttonType?: "button" | "submit" | "reset";
}

export const CombinedTextFieldAndButton = ({
	name,
	label,
	value = "",
	display = "stacked",
	required = false,
	invalid = false,
	valid = false,
	buttonName,
	buttonLabel,
	buttonType = "submit",
	disabled = false,
	theme = "light",
	...extraInputProps
}: CombinedTextFieldAndButtonProps) => {
	return (
		<div
			className={`flex gap-2 flex-col ${
				display === "inline" && "sm:flex-row sm:items-center"
			}`}
		>
			{label && (
				<label
					htmlFor={name}
					className={`${theme === "light" ? "text-secondary-900" : "text-white"} ${display === "inline" && "sm:w-1/3"}`}
				>
					{label}
					{required ? (
						""
					) : (
						<span className="ml-1 text-secondary-500">(optional)</span>
					)}
				</label>
			)}
			<div className={`${display === "inline" && "sm:w-2/3"}`}>
				<div
					className={`flex ${
						invalid
							? `${theme === "light" ? "ring-red-200" : "ring-red-800"} rounded ring-4`
							: valid
								? "ring-positive-100 rounded ring-4"
								: ""
					}`}
				>
					<input
						className={`border border-r-0 p-2 w-full rounded-l ${theme === "light" ? "bg-transparent text-gray-900" : "bg-secondary-dark-input-bg text-white"} ${
							invalid
								? "border-primary"
								: valid
									? "border-positive-500"
									: theme === "light"
										? "border-secondary-200"
										: "border-secondary-700 placeholder:text-secondary-400"
						}`}
						name={name}
						defaultValue={value}
						aria-label={name}
						disabled={disabled}
						type="text"
						{...extraInputProps}
					/>
					<div>
						<Button
							theme={theme}
							className={`${theme === "dark" && "bg-secondary-dark-input-bg hover:bg-secondary-900 text-secondary-400"}`}
							name={buttonName}
							label={buttonLabel}
							type={buttonType}
							styleType="combined"
							disabled={disabled}
							invalid={invalid}
							valid={valid}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
